const environment = {
  production: false,
  environmentName: "sbx",
  apiUrl: "https://sbx-erm-datamigrator.wcgclinical.com/api/",
  ermUrl: "https://sbx-ereviewmanager.wcgclinical.com",
  cnx5Url: "https://dev-connexus.wcgirb.com",
  okta: {
    issuer: "https://preview.wcgclinical.com/oauth2/default",
    baseUrl: "https://preview.wcgclinical.com",
    clientId: "0oapty7d4pmsX2RQL1d7",
    redirectUri:
      "https://sbx-erm-datamigrator.wcgclinical.com/auth/login/callback",
    postLogoutRedirectUri:
      "https://sbx-erm-datamigrator.wcgclinical.com/auth/login",
    scopes: ["openid", "profile", "email", "offline_access"],
    disableHttpsCheck: true,
    useClassicEngine: true,
  },
  maxSessionLength: 24 * 60 * 60 * 1000, // 24 hours
  sessionTimeout: 58 * 60 * 1000, // 58 minutes
  sessionGracePeriod: 2 * 60 * 1000, // 2 minutes
};
export default environment;
